import FullScreenLoading from 'layout/widgets/FullScreenLoading'
import { lazy, Suspense } from 'react'

const AuthPageLazy = lazy(() => import('./index'))

const LazyPageRegister = (props) => (
  <Suspense fallback={<FullScreenLoading />}>
    <AuthPageLazy {...props} />
  </Suspense>
)

export default LazyPageRegister
